import React, { useEffect, useState } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

// css
import "./App.css";
import "./assets/css/reset.css";
import "./assets/css/root.css";

// components
import Home from "./pages/home/index.jsx";
import UploadImage from "./pages/uploadImage";
import ManageImage from "./pages/manageImage";
import Footer from "./components/footer/index.jsx";
import { fetchProtectedData } from "./components/auth/index.jsx";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProtectedData().then((data) => {
      if (data) {
        setLoading(false);
      } else {
        window.location.href =
          "//auth.loukaaa.com/signin?url=" + window.location.origin;
      }
    });
  }, []);

  const router = createBrowserRouter([
    {
      // errorElement: <ErrorPage />,
      path: "/",
      element: (
        <>
          <Outlet />
          <Footer />
        </>
      ),
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/image/upload",
          element: <UploadImage />,
        },
        {
          path: "/image/manage",
          element: <ManageImage />,
        },
      ],
    },
  ]);
  return (
    <div className="App">
      {loading ? (
        <>
          <div className="loading">
            <h2>admin.titou.fr</h2>
          </div>
        </>
      ) : (
        // Affiche le contenu de l'application une fois les données chargées
        <RouterProvider router={router} />
      )}
    </div>
  );
}

export default App;
